import { render, staticRenderFns } from "./ArrayTableCard.vue?vue&type=template&id=3ecfa797"
import script from "./ArrayTableCard.vue?vue&type=script&lang=js"
export * from "./ArrayTableCard.vue?vue&type=script&lang=js"
import style0 from "./ArrayTableCard.vue?vue&type=style&index=0&id=3ecfa797&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports